module.exports = __webpack_public_path__ + "img/57_2.87cfc845.png";